function blockoutDatesForStaffMember(staffMember, staffBlockoutDates) {
  return staffBlockoutDates.filter(staffBlockoutDate => {
    return staffBlockoutDate.attributes.userId == staffMember.id
  })
}

export default blockoutDatesForStaffMember
